import React, {useEffect, useState, useCallback} from 'react';
import {connect} from 'react-redux';
import Resolution from 'engine/Resolution.js';
import {TRIGGER_SAMPLE, RELEASE_SAMPLE} from 'constants/event-types.js';
import StepData from 'pattern/StepData.js';
import RecordedTrigger from 'keyboard/RecordedTrigger.js';
import Colors from 'components/Colors.js';
const colors = new Colors();
const RESOLUTION = new Resolution(32, false);
const STEP_DATA = new StepData();

export default ({track, setLastClicked, selected, recording}) => {
    let {instrument} = track;
    const [recordedTrigger, setRecordedTrigger] = useState(undefined);
    let [lastTrigger, setLastTrigger] = useState(0);
    let [lastRelease, setLastRelease] = useState(0);

    let isPlaying = lastTrigger > lastRelease;
    let sample = instrument.defaultSampler && instrument.defaultSampler.sample;

    const onMouseDown = useCallback(() => {
        if (track.sequencerEngine.state.keyboard.isCommandDown) {
            setLastClicked(track);
            return;
        }
        if (instrument.defaultSampler.loop && isPlaying) {
            instrument.triggerRelease();
        } else {
            instrument.triggerAttack();
        }

        if (recording) {
            setRecordedTrigger(new RecordedTrigger(
                track,
                0,
                RESOLUTION,
                track.sequencerEngine,
                true));
                
        }
        setLastClicked(track);
    }, [instrument, track, recording, setRecordedTrigger, isPlaying]);

    const onMouseUp = useCallback(() => {
        if (track.gated) {
            instrument.triggerRelease();
        }
        if (recording && recordedTrigger) {
            recordedTrigger.record();
            setRecordedTrigger(undefined);
        }
    }, [instrument, track, recording, recordedTrigger, setRecordedTrigger]);

    const onTrigger = useCallback((e) => {
        if (e.trackNumber === track.trackNumber) {
            setTimeout(() => {
                setLastTrigger(new Date().getTime() + e.duration);
                if (e.duration > 0) {
                    setTimeout(onRelease, e.duration * 1000);
                }
            }, e.time);
        }
    }, [track, setLastTrigger, onRelease]);

    const onRelease = useCallback((e) => {
        if (e === undefined ||
            e.trackNumber === track.trackNumber) {
            setLastRelease(new Date().getTime());
        }
    }, [track, setLastRelease]);

    const addEventListeners = () => {
        window.addEventListener(TRIGGER_SAMPLE, onTrigger);
        window.addEventListener(RELEASE_SAMPLE, onRelease);
    };

    const removeEventListeners = () => {
        window.removeEventListener(TRIGGER_SAMPLE, onTrigger);
        window.removeEventListener(RELEASE_SAMPLE, onRelease);
    };

    useEffect(() => {
        addEventListeners();
        return removeEventListeners;
    }, []);

    let className = "sampler-trigger";
    if (isPlaying) {
        className += " triggering";
    }

    if (selected) {
        className += " selected";
    }
    if (sample && sample.videoId) {
        return (
            <img
              draggable={false}
              onMouseDown={onMouseDown}
              onMouseUp={onMouseUp}
              onMouseLeave={onMouseUp}
              className={className}
              src={sample.getThumbnail()}/>
        );
    }

    let color = colors.getColorForTrack(track);
    let style = {
        backgroundColor: color
    };
    return (
        <div
          draggable={false}
          onMouseDown={onMouseDown}
          onMouseUp={onMouseUp}
          onMouseLeave={onMouseUp}
          style={style}
          className={className}>
        </div>
    );
}


